import { Component, Vue, Prop } from 'vue-property-decorator'

// Enums
import { ItemType } from '@/enums/ItemEnums'

@Component
export default class Item extends Vue {
  @Prop() datas

  get categoryId() {
    // Since we only return -1 for category
    // return this.datas.subCategory.id
    return this.datas.category
  }

  get identifier() {
    return this.datas.type === ItemType.Car ? 'register' : 'propertyname_uniquereference'
  }

  get itemTypeTitle() {
    switch (this.datas.type) {
      case (ItemType.Car):
        return `(${this.$t('global.category.car')})`
        break
      case (ItemType.Realty):
        return `(${this.$t('global.category.estate')})`
        break
      case (ItemType.Others):
        return `(${this.$t('global.category.others')})`
        break
    }
    return ''
  }
}
